/* eslint-disable */
import React, { useEffect } from "react";
import { Col, Row, Space } from "antd";
import DynamicButton from "./DynamicButton";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchSendCollectedFeedback,
  nextPage,
  previousPage,
  resetWidget,
} from "Redux/actions";
import { debounce } from "lodash";
import PrivacyPolicyHolder from "./PrivacyPolicyHolder";

const ButtonHolder = ({ onSubmit }) => {
  const {
    currentPage,
    maxPage,
    pages,
    isFinal,
    widgetJSON,
    pageComponents,
    selectedLanguage,
  } = useSelector((state) => state) || {};

  const { general_settings = {} } = widgetJSON.data || {};
  const dispatch = useDispatch();

  const buttonHandle = (type) => {
    const {
      customer_data = null,
      custom_field_feedback_component = null,
      comment_data = null,
      sli_data = null,
    } = pages[currentPage];
    if (
      type !== "prev" &&
      (customer_data ||
        custom_field_feedback_component ||
        comment_data ||
        sli_data ||
        currentPage > maxPage ||
        (general_settings.is_enable_policy && currentPage === maxPage))
    ) {
      onSubmit();
    } else {
      switch (type) {
        case "prev": {
          dispatch(previousPage());
          break;
        }
        case "next": {
          dispatch(nextPage());
          break;
        }
        case "submit": {
          dispatch(fetchSendCollectedFeedback());
          break;
        }
      }
    }
  };

  // const goTop = () => {
  //   switchToNextPage();
  //   window.scroll({
  //     top: 0,
  //     left: 0,
  //     behavior: "smooth",
  //   });
  // };

  const { properties = null } = pages[currentPage] || {};
  const { back_button_text, next_button_text, submit_button_text } =
    general_settings || {};

  const { languages = [] } = pages["0"] || [];

  return (
    <>
      {currentPage <= maxPage && properties && (
        <Row
          justify="center"
          style={{
            margin: general_settings.is_enable_policy ? "0 0 20px" : "20px 0",
          }}
        >
          {currentPage === maxPage && general_settings.is_enable_policy && (
            <Col xs={24} style={{ marginBottom: "20px" }}>
              <PrivacyPolicyHolder data={general_settings} />
            </Col>
          )}
          <Col>
            <div
              style={{
                width: "100%",
                display: "flex",
                flexDirection: "column",
                gap: 8,
              }}
            >
              {!(
                pageComponents?.length === 1 &&
                pageComponents[0]?.attrs?.service?.length === 1
              ) &&
                (isFinal ? (
                  <DynamicButton
                    button={{
                      enabled: true,
                      color: properties.submit_button_txt_color,
                      backgroundColor: properties.submit_button_bg_color,
                      title: submit_button_text
                        ? submit_button_text[selectedLanguage]
                        : "Submit",
                    }}
                    handleClick={() => buttonHandle("submit")}
                  />
                ) : (
                  <DynamicButton
                    button={{
                      enabled: properties.is_next_button_enabled,
                      color: properties.next_button_txt_color,
                      backgroundColor: properties.next_button_bg_color,
                      title: next_button_text
                        ? next_button_text[selectedLanguage]
                        : "Next",
                    }}
                    handleClick={() => buttonHandle("next")}
                  />
                ))}
              {/* {!(currentPage === maxPage) &&
                !isFinal &&
                !(
                  pageComponents?.length === 1 &&
                  pageComponents[0]?.attrs?.service?.length === 1
                ) && (
                )} */}
              {((currentPage === 1 && pages["0"] && languages?.length > 1) ||
                currentPage > 1) && (
                <DynamicButton
                  button={{
                    enabled: properties.is_back_button_enabled,
                    color: properties.back_button_txt_color,
                    backgroundColor: properties.back_button_bg_color,
                    title: back_button_text
                      ? back_button_text[selectedLanguage]
                      : "Back",
                  }}
                  handleClick={() => buttonHandle("prev")}
                />
              )}
            </div>
          </Col>
        </Row>
      )}
    </>
  );
};

export default ButtonHolder;
